import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

import { observable, set, runInAction, flow } from "mobx";
import { locationRestLicenseDelete, locationRestLicenseRetry } from "../wp-api";
import { request } from "../utils";
let License = (_class = class License {
  constructor(license, store) {
    _initializerDefineProperty(this, "busy", _descriptor, this);

    _initializerDefineProperty(this, "blog", _descriptor2, this);

    _initializerDefineProperty(this, "host", _descriptor3, this);

    _initializerDefineProperty(this, "programmatically", _descriptor4, this);

    _initializerDefineProperty(this, "blogName", _descriptor5, this);

    _initializerDefineProperty(this, "installationType", _descriptor6, this);

    _initializerDefineProperty(this, "code", _descriptor7, this);

    _initializerDefineProperty(this, "hint", _descriptor8, this);

    _initializerDefineProperty(this, "remote", _descriptor9, this);

    _initializerDefineProperty(this, "noUsage", _descriptor10, this);

    this.store = void 0;
    this.retry = flow(function* () {
      this.busy = true;

      try {
        const result = yield request({
          location: locationRestLicenseRetry,
          params: {
            slug: this.store.slug,
            blogId: this.blog
          }
        });
        set(this, result);
      } catch (e) {
        console.log(e);
        throw e;
      } finally {
        this.busy = false;
      }
    });
    this.deactivate = flow(function* () {
      this.busy = true;

      try {
        const result = yield request({
          location: locationRestLicenseDelete,
          params: {
            slug: this.store.slug,
            blogId: this.blog
          }
        });
        set(this, result);
      } catch (e) {
        console.log(e);
        throw e;
      } finally {
        this.busy = false;
      }
    });
    runInAction(() => set(this, license));
    this.store = store;
  } // eslint-disable-next-line @typescript-eslint/member-ordering


}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "busy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "blog", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "host", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "programmatically", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "blogName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "installationType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "code", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "hint", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "remote", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "noUsage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { License };